import 'phaser'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { layers } from '../main/layers-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { ITileDataShip } from './tilesDataShip'

export interface ITileSelector extends IEntity {
  x: number
  y: number
  image: Phaser.GameObjects.Image
  data: ITileDataShip
}

const objs: ITileSelector[] = []

export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

export function create(
  data: ITileDataShip,
  x: number,
  y: number,
): ITileSelector {
  let id = common.createId()

  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().ui,
    data.frameInfo,
    x,
    y,
  )

  let obj: ITileSelector = {
    eType: 'tile-selector',
    id,
    x,
    y,
    image,
    data,
    isDead: false,
  }
  objs.push(obj)
  return obj
}

export function kill(obj: ITileSelector) {
  obj.isDead = true
}

export function killAll() {
  l.forEach(objs, (c) => {
    c.isDead = true
  })
}

export function updateAll() {
  // objs.forEach((c) => {
  //   update(c)
  // })
  // entitiesUtils.removeDead(objs, (c) => {
  //   if (c.imageFloor) {
  //     c.imageFloor.destroy()
  //   }
  //   if (c.imageWall) {
  //     c.imageWall.destroy()
  //   }
  //   if (c.imageShadow) {
  //     c.imageShadow.destroy()
  //   }
  // })
}
